var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2721 1.58594H18.0833L11.9416 8.60551L19.1668 18.1576H13.5095L9.07852 12.3643L4.00845 18.1576H1.19552L7.76469 10.6494L0.833496 1.58594H6.63442L10.6397 6.88121L15.2721 1.58594ZM14.2854 16.4749H15.8432L5.78799 3.18021H4.11638L14.2854 16.4749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon2);
export default __webpack_public_path__ + "static/media/twitter_icon 2.6fe7b30d9ec4024669f888a317f1b4d5.svg";
export { ForwardRef as ReactComponent };